var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.303,
    height: 66.853,
    viewBox: "0 0 57.303 66.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_awesome-css3-alt"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-css3-alt-2",
    "data-name": "Icon awesome-css3-alt",
    d: "M0,2.25,5.208,61.314,28.651,69.1l23.443-7.79L57.3,2.25ZM46.723,14.188l-.716,7.058L28.8,28.6l-.045.015H45.395l-1.91,21.877L28.83,54.778,14.087,50.42l-.955-11.028h7.3l.478,5.715,7.849,1.985,8.163-2.3.552-9.192-24.816-.075v-.015l-.03.015-.537-6.909,16.728-6.969.97-.4H11.446l-.866-7.058Z",
    transform: "translate(0 -2.25)",
    fill: "#006151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_awesome-css3-alt)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-css3-alt-3",
    "data-name": "Icon awesome-css3-alt",
    d: "M0,2.25,5.208,61.314,28.651,69.1l23.443-7.79L57.3,2.25ZM46.723,14.188l-.716,7.058L28.8,28.6l-.045.015H45.395l-1.91,21.877L28.83,54.778,14.087,50.42l-.955-11.028h7.3l.478,5.715,7.849,1.985,8.163-2.3.552-9.192-24.816-.075v-.015l-.03.015-.537-6.909,16.728-6.969.97-.4H11.446l-.866-7.058Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.3b8b4ffeed9357e898ae4f754475084e.svg";
export { ForwardRef as ReactComponent };